module.exports = __webpack_public_path__ + "static/media/กุน.6aaf9ca5.png";